// extracted by mini-css-extract-plugin
export default {"products":"wA-z","card":"xA-z","oosMessaging":"yA-z"};